import React from "react";
import "./BirthImpDoc.css";
const BirthImpDoc = () => {
  return (
    <div className="birthImpDocContainer">
      <h2>
        Important Documents Necessary for Birth Certificate{" "}
        <span>Attestation</span> in Bangalore
      </h2>
      <p>
        The key documents required for birth certificate attestation in
        Bangalore include:
      </p>
      <div className="birthImpDocContent">
        <ul>
          <li>
            <span>Original certificate</span>
          </li>
          <li>
            <span>Passport copy</span>
          </li>
        </ul>
      </div>
      <p>
        Birth certificate attestation has a very significant importance
        globally. The attestation procedure of a birth certificate will improve
        the quality and acceptance of the certificate in the destination
        country. Birth certificates hold immense importance in an individual’s
        life. The certificate records essential details regarding the infant and
        the parentage. By enrolling the birth certificate with the government,
        the person becomes a member of a concerned community. A birth
        certificate can also be called the fundamental and primary certificate
        of a person. This document is essential throughout an individual's life.
        Typically, a birth certificate is issued by the concerned doctor or
        hospital.
      </p>
    </div>
  );
};

export default BirthImpDoc;
